<div class="main-box" [ngClass]="{ 'reverse': isImageLeft}">
  <div class="imagebox" [ngClass]="{ 'reverse': isImageLeft, 'has-appbtns': showAppBtns && hasAppLinks }">
    <div class="imagebox-content">
      <h3 class="imagebox-content-title">{{ heading }}</h3>
      <h3 class="imagebox-content-description" [innerHtml]="description"></h3>
      <div class="imagebox-content-appbtns" *ngIf="showAppBtns && hasAppLinks">
        <app-googleplay-btn></app-googleplay-btn>
        <app-applestore-btn></app-applestore-btn>
      </div>
      <ng-content></ng-content>
    </div>
    <div class="imagebox-image">

      <img class="footer-img" [ngClass]="largimg" src="{{ image }}" [style]="imageStyle" />
        <img  class="mobile-img" [ngClass]="smallimg" src="{{ image }}" [style]="imageStyle" />


    </div>

  </div>
  <div class="gradient-image">
    <img src="{{ gradientimage }}" />

  </div>
</div>